import { render, staticRenderFns } from "./DownloadPictures.vue?vue&type=template&id=0b4285be&"
import script from "./DownloadPictures.vue?vue&type=script&lang=js&"
export * from "./DownloadPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports